// Route guard for the BA screens (BA P1.6a): a direct URL opens only when the
// company is strictly entitled to brand_ambassadors (E3's useBaEnabled);
// otherwise back to the dashboard, like the other entitlement-gated routes.
// UX only — employee-service answers 404 regardless.
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useBaEnabled } from '@/features/entitlements/brandAmbassadors';

export const BaRoute: React.FC<{ children: React.ReactNode; fallback?: string }> = ({ children, fallback = '../dashboard' }) => {
  const { loaded, enabled } = useBaEnabled();
  if (!loaded) return <div className="p-8 text-center text-muted-foreground">…</div>;
  return enabled ? <>{children}</> : <Navigate to={fallback} replace />;
};

export default BaRoute;
